/**
 * Datum und Zahl in deutscher Schreibweise — überall gleich.
 *
 * Der Testbericht zu Version 0.2.0 fand „4.6.2027“ neben „04.06.2027“,
 * „30.9.2027“, „2.4“, „12.0“ und „144.00h“ (Teil E, U6). Jede Maske hatte ihre
 * eigene Formatierung; diese Helfer sind die eine.
 */

const DATUM = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
const DATUM_ZEIT = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** Ein reines Datum „YYYY-MM-DD“ ohne Zeitzonenverschiebung lesen; alles andere wie gegeben. */
function alsDatum(wert: string | number | Date): Date {
  if (typeof wert === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(wert)) {
    const [j, m, t] = wert.split('-').map(Number);
    return new Date(j, m - 1, t);
  }
  return wert instanceof Date ? wert : new Date(wert);
}

/** „04.06.2027“ — `fallback`, wenn kein gültiges Datum vorliegt. */
export function formatDate(wert: string | number | Date | null | undefined, fallback = '—'): string {
  if (wert === null || wert === undefined || wert === '') return fallback;
  const d = alsDatum(wert);
  return Number.isNaN(d.getTime()) ? fallback : DATUM.format(d);
}

/** „25.10.2026, 13:08“ */
export function formatDateTime(wert: string | number | Date | null | undefined, fallback = '—'): string {
  if (wert === null || wert === undefined || wert === '') return fallback;
  const d = alsDatum(wert);
  return Number.isNaN(d.getTime()) ? fallback : DATUM_ZEIT.format(d);
}

/**
 * „2,4“, „12“, „144,5“ — höchstens `maxDigits` Nachkommastellen, ohne
 * überflüssige Nullen; `minDigits` erzwingt welche („144,0“).
 * Zeichenketten aus der Datenbank („144.00“) werden als Zahl gelesen.
 */
export function formatNumber(
  wert: number | string | null | undefined,
  maxDigits = 2,
  minDigits = 0,
  fallback = '—',
): string {
  if (wert === null || wert === undefined || wert === '') return fallback;
  const n = typeof wert === 'number' ? wert : Number(wert);
  if (!Number.isFinite(n)) return fallback;
  return n.toLocaleString('de-DE', { minimumFractionDigits: minDigits, maximumFractionDigits: maxDigits });
}

/** „144,0 h“ */
export function formatHours(wert: number | string | null | undefined, fallback = '—'): string {
  const zahl = formatNumber(wert, 1, 1, '');
  return zahl ? `${zahl} h` : fallback;
}

/** „Q2“ — ein Quartal als Zahl oder Zeichenkette. */
export function formatQuarter(wert: number | string | null | undefined, fallback = '—'): string {
  if (wert === null || wert === undefined || wert === '') return fallback;
  const q = String(wert).replace(/^Q/i, '');
  return /^[1-4]$/.test(q) ? `Q${q}` : String(wert);
}
